import styled from 'styled-components/macro'
import { motion } from 'framer-motion'

import { breakpoints, mq } from 'styles/mq'
import { StyledSection } from '../section/styled'
import { NavButton } from '../nav-button'

export const multiColumnBreakpoint = `${breakpoints.medium} and (min-height: 50rem)`

export const ScrollContainer = styled(StyledSection).attrs({
  as: motion.section,
})``

export const Content = styled.div`
  --height-offset: 15rem;
  --top-offset: 6rem;

  position: sticky;
  top: calc(var(--header-height) + var(--top-offset));
  height: calc(100vh - var(--header-height) - var(--height-offset));
  height: calc(100dvh - var(--header-height) - var(--height-offset));
  margin-bottom: 4rem;
  font-size: 1.4rem;
  border: 1px solid #ccc;
  background-color: white;
  z-index: 1;

  ${mq.smallOnly} {
    margin-left: calc(-1 * var(--container-spacing));
    margin-right: calc(-1 * var(--container-spacing));
    border-width: 1px 0;
  }

  ${mq.medium} {
    --height-offset: 18rem;
    --top-offset: 9rem;

    font-size: 1.6rem;
  }

  ${mq.large} {
    font-size: 1.8rem;
  }

  > div {
    position: relative;
    height: 100%;
    max-width: 70rem;
    margin: 0 auto;
    padding: 1.5rem;
    text-align: justify;
    hyphens: auto;
    gap: 2.4em;
    overflow: hidden;

    > :first-child {
      margin-top: 0;
    }
    > :last-child {
      margin-bottom: 0;
    }

    @media ${multiColumnBreakpoint} {
      padding: 3em;
      column-width: 20em;
      orphans: 3;
      widows: 3;
      max-width: none;
      margin: 0;
    }
  }

  figure {
    margin: 1em 0;

    img {
      display: block;
      width: 100%;
      aspect-ratio: 16 / 9;
      object-fit: cover;
    }

    figcaption {
      font-size: 80%;
      padding: 0.5em 0;
      color: #555;
      border-bottom: 1px dotted currentColor;
    }

    [data-clickable] {
      cursor: pointer;
    }
  }
`

export const PrevButton = styled(NavButton)`
  position: sticky;
  top: calc(var(--header-height) + 3rem);

  ${mq.medium} {
    top: calc(var(--header-height) + 4.5rem);
  }
`

export const NextButton = styled(NavButton)<{ isFollowedByLongread?: boolean }>`
  position: sticky;
  top: calc(100vh - var(--header-height));
  top: calc(100dvh - var(--header-height));
  margin-bottom: -1.5rem;

  ${mq.medium} {
    top: calc(100vh + 2rem - var(--header-height));
    margin-bottom: ${props => (props.isFollowedByLongread ? -13.3 : -8.3)}rem;
  }
`
